<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Язык и&nbsp;регион</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте проверим языковые настройки и&nbsp;валюту проекта.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Данные проекта&raquo;. На&nbsp;появившейся странице
              выберите &laquo;Язык и&nbsp;регион&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/yazyk-i-region-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnaya-informacija"
            class="typography__headline2"
          >
            Основная информация
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Данные раздела заранее выбираются автоматически. Проверьте, возможно понадобится что-то изменить.</p>

            <p>
              После изменений нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После успешного сохранения
              увидите в&nbsp;правом верхнем углу уведомление.
            </p>

            <p>
              С&nbsp;языком и&nbsp;региональными настройками разобрались. Самое время перейти к&nbsp;настройке
              <BaseLink
                class="ui-link-secondary"
                to="/faq/articles/uvedomleniya"
                >уведомлений проекта</BaseLink
              >.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/yazyk-i-region-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Данные проекта",
    url: "/faq/categories/dannyye-proyekta",
  },
  {
    name: "Язык и&nbsp;регион",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основная&nbsp;информация",
    url: "osnovnaya-informacija",
  },
];

const relatedArticles = [
  {
    name: "Настройка меню CRM",
    slug: "nastroyka-menyu-crm",
  },
  {
    name: "Общие настройки",
    slug: "obshchiye-nastroyki",
  },
  {
    name: "Контакты и&nbsp;данные филиалов",
    slug: "kontakty-i-dannye-filialov",
  },
  {
    name: "Уведомления",
    slug: "uvedomleniya",
  },
];

useSeoMeta({
  title: "Язык и регион",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
